// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f21a7c2a","513":"9bdd41bb","703":"8dc19e5b"}[chunkId] + ".chunk.js";
};